import {FC, useMemo} from "react";
import { FlexBox } from "@brg/ui";
import {useTranslation} from "react-i18next";
import {RectangularButtonFilled, RectangularButtonHollow} from "../buttons";
import styled from "styled-components";
import {LayoutConst, useModal} from "../../../core";
import {useHistory} from "react-router-dom";
import {useProfile} from "@brg/auth";
import {checkIsLongreadAndTeamOwner} from "../../helpers/designer/checkIsLongreadAndTeamOwner";
import {bProfile} from "../../../core/utils/bProfile";
import { ModerationType } from "../../pages/teams/const/ModerationTypes";

const LongreadButtonFilled = styled(RectangularButtonFilled)`
  padding: 0 24px;
  height: 38px !important;
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 38px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    height: 36px!important;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    height: 44px!important;
  }
`

const LongreadButtonHollow = styled(RectangularButtonHollow)`
  padding: 0 24px;
  height: 38px !important;
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 38px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    height: 36px!important;
  }

  @media(max-width: ${LayoutConst.screen.s}px) {
    width: 100%;
    height: 44px!important;
  }
`

const Wrapper = styled(FlexBox)`
  row-gap: 16px;

  @media(max-width: ${LayoutConst.screen.s}px) {
    width: 100%;
    flex-direction: column;
  }
`

export const LongreadShopButtons: FC<{project: any, isBottomBlock?: boolean}> = ({project, isBottomBlock}) => {
    const { t } = useTranslation();
    const modal = useModal();
    const history = useHistory();
    const profile = useProfile();
    const isModer = useMemo(() => profile && (bProfile.isModer(profile) || bProfile.isSuperModer(profile)), [profile]);

    const shouldVisibleAttachProductButton = useMemo(() => {
        if (!isBottomBlock) return false;
        return checkIsLongreadAndTeamOwner(project, profile?.accountId || "")
    }, [project, profile, isBottomBlock])

    const shouldVisibleButtons = useMemo(() => {
        if (!project && !project?.teams) return false;
        if (project?.teams?.length === 0) return false;
        return Boolean(project?.teams?.[0]?.teamId && [ModerationType.Own, ModerationType.OwnWithoutTag]?.includes(project?.teams?.[0]?.moderationType));
    }, [project, profile])

    const teamId = useMemo(() => {
        if (!project && !project?.teams) return undefined;
        if (project?.teams?.length === 0) return undefined;
        return project?.teams?.[0]?.teamId;
    }, [project])


    if (!shouldVisibleButtons || !isModer || project?.isBook) return null;

    return <Wrapper gx={24}>
        <LongreadButtonFilled onClick={() => history.push(`/teams/${teamId}/shop?longreadId=${project?.projectId}`)}>{t(`shop.${isBottomBlock ? 'other_products' : 'longread_products'}`)}</LongreadButtonFilled>
        {shouldVisibleAttachProductButton && <LongreadButtonHollow onClick={() => modal.show('shop-sent', {project: project})}>{t('shop.attach_product_upper')}</LongreadButtonHollow>}
    </Wrapper>
}import {FC, useMemo} from "react";
import { FlexBox } from "@brg/ui";
import {useTranslation} from "react-i18next";
import {RectangularButtonFilled, RectangularButtonHollow} from "../buttons";
import styled from "styled-components";
import {LayoutConst, useModal} from "../../../core";
import {useHistory} from "react-router-dom";
import {useProfile} from "@brg/auth";
import {checkIsLongreadAndTeamOwner} from "../../helpers/designer/checkIsLongreadAndTeamOwner";
import {bProfile} from "../../../core/utils/bProfile";
import { ModerationType } from "../../pages/teams/const/ModerationTypes";

const LongreadButtonFilled = styled(RectangularButtonFilled)`
  padding: 0 24px;
  height: 38px !important;
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 38px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    height: 36px!important;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    height: 44px!important;
  }
`

const LongreadButtonHollow = styled(RectangularButtonHollow)`
  padding: 0 24px;
  height: 38px !important;
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 38px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    height: 36px!important;
  }

  @media(max-width: ${LayoutConst.screen.s}px) {
    width: 100%;
    height: 44px!important;
  }
`

const Wrapper = styled(FlexBox)`
  row-gap: 16px;

  @media(max-width: ${LayoutConst.screen.s}px) {
    width: 100%;
    flex-direction: column;
  }
`

export const LongreadShopButtons: FC<{project: any, isBottomBlock?: boolean}> = ({project, isBottomBlock}) => {
    const { t } = useTranslation();
    const modal = useModal();
    const history = useHistory();
    const profile = useProfile();
    const isModer = useMemo(() => profile && (bProfile.isModer(profile) || bProfile.isSuperModer(profile)), [profile]);

    const shouldVisibleAttachProductButton = useMemo(() => {
        if (!isBottomBlock) return false;
        return checkIsLongreadAndTeamOwner(project, profile?.accountId || "")
    }, [project, profile, isBottomBlock])

    const shouldVisibleButtons = useMemo(() => {
        if (!project && !project?.teams) return false;
        if (project?.teams?.length === 0) return false;
        return Boolean(project?.teams?.[0]?.teamId && [ModerationType.Own, ModerationType.OwnWithoutTag]?.includes(project?.teams?.[0]?.moderationType));
    }, [project, profile])

    const teamId = useMemo(() => {
        if (!project && !project?.teams) return undefined;
        if (project?.teams?.length === 0) return undefined;
        return project?.teams?.[0]?.teamId;
    }, [project])


    if (!shouldVisibleButtons || !isModer || project?.isBook) return null;

    return <Wrapper gx={24}>
        <LongreadButtonFilled onClick={() => history.push(`/teams/${teamId}/shop?longreadId=${project?.projectId}`)}>{t(`shop.${isBottomBlock ? 'other_products' : 'longread_products'}`)}</LongreadButtonFilled>
        {shouldVisibleAttachProductButton && <LongreadButtonHollow onClick={() => modal.show('shop-sent', {project: project})}>{t('shop.attach_product_upper')}</LongreadButtonHollow>}
    </Wrapper>
}